import { Component, OnInit } from '@angular/core';
import { HeaderMaxtrack } from 'src/app/core/enums/headers-maxtrack.enum';
import { Buffer } from 'buffer';
import { MaxtrackService } from 'src/app/core/services/maxtrack.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-translate-maxtrack',
  templateUrl: './translate-maxtrack.component.html',
  styleUrls: ['./translate-maxtrack.component.scss'],
})
export class TranslateMaxtrackComponent implements OnInit {
  circularProgressiveWait = false;
  packet = '';
  packetTranslated = {};
  packetHeader: any;
  headerMap: any = Object(HeaderMaxtrack);
  public prettyEvent: string = '0';

  profileFilesName: { fileId: Number; name: String }[] = [];
  profileSelect: any = undefined;
  fileDocumentContents = '';
  packetDocumentContents = '';
  packetProfileDiff = '';
  public prettyEventDiffPacket: string = '0';
  public prettyEventDiffFile: string = '0';

  circularProgressiveDiffConfigWait = false;

  constructor(
    private maxtrackService: MaxtrackService,
    public toastService: ToastService
  ) {}

  translate(data: string) {
    this.packetTranslated = {};
    this.circularProgressiveWait = true;
    this.maxtrackService.translate(data.trim()).subscribe(
      (response: any) => {
        try {
          let responseJSON = JSON.parse(response);
          this.packetHeader = responseJSON.mt;
          const aux = responseJSON.response
            .split('')
            .filter((char: string) => {
              const code = char.charCodeAt(0);
              return code >= 32 && code <= 126;
            })
            .join('');
          let openDataParse = responseJSON.openData ? responseJSON.openData : "";
          this.packetTranslated = {
            mt: responseJSON.mt,
            message: JSON.parse(aux),
            openDataParse: openDataParse,
          };
        } catch (error: any) {
          let responseJSON = JSON.parse(response);
          this.packetHeader = responseJSON.mt;
          let openDataParse = responseJSON.openData ? responseJSON.openData : "";
          this.packetTranslated = {
            mt: responseJSON.mt,
            message: responseJSON.response,
            openDataParse: openDataParse,
          };
        }
        this.circularProgressiveWait = false;
      },
      (error: any) => {
        //let responseJSON = JSON.parse(error);
        this.toastService.show(
          'Não foi possível traduizr o pacote, tente no gateway_python',
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
        //let responseJSON = JSON.parse(error.message);
        // this.packetTranslated = {
        //   mt: responseJSON.mt,
        //   message: responseJSON.response,
        // };
        this.circularProgressiveWait = false;
      }
    );
  }

  requestProfileList() {
    this.maxtrackService.profileFilesName().subscribe((response: any) => {
      this.profileFilesName = response;
    });
  }
  translateAndRequestProfile() {
    this.fileDocumentContents = '';
    this.packetDocumentContents = '';
    if (this.profileSelect) {
      this.circularProgressiveDiffConfigWait = true;
      this.maxtrackService
        .diffConfig(this.profileSelect, this.packetProfileDiff)
        .subscribe(
          (response: any) => {
            this.fileDocumentContents = JSON.parse(response.profileFile);
            this.packetDocumentContents = JSON.parse(response.profilePacket);

            this.toastService.show('Sucesso ao traduzir pacotes', {
              classname: 'bg-success text-center text-white',
              delay: 10000,
            });
            this.circularProgressiveDiffConfigWait = false;
          },
          (error: HttpErrorResponse) => {
            this.toastService.show(
              'Erro ao traduzir pacotes - ' + error.message,
              {
                classname: 'bg-danger text-center text-white',
                delay: 10000,
              }
            );
            this.circularProgressiveDiffConfigWait = false;
          }
        );
    }
  }

  ngOnInit(): void {}
}
